import { gql } from "@apollo/client";

import { OrganizationCareerTrackFragment } from "./get-organization-career-track-query";

export default gql`
  ${OrganizationCareerTrackFragment}
  mutation saveOrgWideCareerTrack(
    $careerTrackId: Int
    $organizationId: Int
    $teamId: Int
    $title: String
    $roles: [CareerTrackRoleInput]
    $deleteRoleIds: [Int!]
    $additionalCompetencies: [Int]
    $baseVersion: String
  ) {
    createOrUpdateCareerTrack(
      careerTrackId: $careerTrackId
      organizationId: $organizationId
      teamId: $teamId
      title: $title
      roles: $roles
      deleteRoleIds: $deleteRoleIds
      additionalCompetencies: $additionalCompetencies
      baseVersion: $baseVersion
    ) {
      careerTrack {
        ...OrganizationCareerTrackFragment
      }
      createdIds {
        clientId
        id
        kind
      }
    }
  }
`;
